const auditLog = {
  searchPlaceholder: "Поиск в журнале...",
  filters: "Фильтры",
  clearFilters: "Очистить",
  refresh: "Обновить",
  source: "Источник",
  actorType: "Тип актора",
  dateFrom: "С",
  dateTo: "По",
  allSources: "Все источники",
  systemLogs: "Система",
  documentLogs: "Документы",
  allActors: "Все акторы",
  actorUser: "Пользователь",
  actorSubmitter: "Подписант",
  actorSystem: "Система",
  actorAutomation: "Автоматизация",
  colTimestamp: "Время",
  colSource: "Источник",
  colActor: "Актор",
  colAction: "Действие",
  colTarget: "Цель",
  noEntries: "Записей в журнале не найдено",
  showing: "Показано",
  of: "из",
  oldData: "Предыдущее значение",
  newData: "Новое значение",
} as const;
export default auditLog;
